import { imageDialogStateVar } from 'src/editor/AlineEditor';
import { editorImageMimeTypes } from 'src/helpers/integrations/filestack';
import { pushNotification } from 'src/notifications';

/** Open the image dialog with a pasted or dropped image, or tell the user its format is not supported. */
export function openImageDialogWithImage(image: Blob): void {
  const isSupported = editorImageMimeTypes.some(mimeType => mimeType === image.type);
  if (!isSupported) {
    pushNotification({
      message: 'This image format is not supported. Use a PNG, JPEG, GIF or BMP image.',
      variant: 'error',
    });
    return;
  }

  imageDialogStateVar({ initialImage: image, open: true });
}
